"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    ReceiptLine: ()=>ReceiptLine
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const index_cjs_namespaceObject = require("../../utils/index.cjs");
const external_IconButton_index_cjs_namespaceObject = require("../IconButton/index.cjs");
const Span_cjs_namespaceObject = require("../Text/Span.cjs");
const external_Tooltip_index_cjs_namespaceObject = require("../Tooltip/index.cjs");
const external_ReceiptLine_variants_cjs_namespaceObject = require("./ReceiptLine.variants.cjs");
const external_ReceiptLineLabel_cjs_namespaceObject = require("./ReceiptLineLabel.cjs");
const external_ReceiptLineValue_cjs_namespaceObject = require("./ReceiptLineValue.cjs");
const VALID_LABEL_TYPES = [
    'string',
    'plainButton'
];
const VALID_RECEIPT_LINE_STRING_TYPES = [
    'string',
    'stringRetail',
    'stringSale',
    'stringUrgency',
    'stringCustomer'
];
const VALID_RECEIPT_LINE_PRICE_TYPES = [
    'price',
    'priceCustomer',
    'priceRetail',
    'priceSale',
    'priceUrgency',
    'total',
    'totalRetail',
    'totalSale',
    'totalUrgency',
    'totalCustomer'
];
const VALID_RECEIPT_LINE_TOTAL_TYPES = [
    'total',
    'totalRetail',
    'totalSale',
    'totalUrgency',
    'totalCustomer'
];
const VALID_RECEIPT_TYPES = [
    'info',
    'price',
    'totalGreen',
    'numberOfNights',
    'taxesAndFees',
    'pricePerNight',
    'numberOfTravelers',
    'standard',
    'dueNow',
    'dueAtPickup',
    'pricelineTripNumber',
    'purchaseDate',
    'paymentMethod',
    'billingLabel',
    'forfeitedCredit',
    'remainingBalance',
    'packageSavings',
    'creditApplied',
    'coupon',
    'totalCost',
    'totalCostHeading',
    'totalCostHeadingWithSubText',
    'youPayTotal',
    'youPayToday',
    'totalCharges',
    'totalCharged',
    'totalOriginalCharged',
    'availableCredit',
    'milesYouEarn',
    'freeSpiritPoints',
    'fees',
    'protection',
    'subText',
    'affirmFeesMonth',
    'affirmFeesMo',
    'affirmInterestFreePayments',
    'creditAppliedInBold'
];
function ReceiptLine({ className, receiptLineType = 'string', bold = false, label, labelType = 'string', onClickLabel, valueType = 'string', value, onClickValue, withHelperIcon = false, helperIconText = '', pricePrefix, currencyCode, currencyCode2, price, price2, priceTextStyle = 'body2', withStrikethroughAbove = false, strikethroughPricePrefix, strikethroughCurrencyCode, strikethroughPrice, strikethroughTextStyle = 'body2', strikeThroughPallete = 'neutral', strikeThroughBold = false, withSubPrice = false, subCurrencyCode, subPrice, subPriceTextStyle = 'body2', subPricePallete = 'neutral', subPriceBold = false, receiptType = '', ...props }) {
    const isLabelStringOrPlainButton = VALID_LABEL_TYPES.includes(labelType);
    const isValuePrice = VALID_RECEIPT_LINE_PRICE_TYPES.includes(receiptLineType);
    const VALID_RECEIPT_LINE_VALUE_TYPES = [
        'string',
        'plainButton'
    ];
    const isValueStringOrPlainButton = VALID_RECEIPT_LINE_STRING_TYPES.includes(receiptLineType) || VALID_RECEIPT_LINE_VALUE_TYPES.includes(valueType);
    const isReceiptLineBold = VALID_RECEIPT_LINE_TOTAL_TYPES.includes(receiptLineType) || bold;
    const isValidReceiptType = VALID_RECEIPT_TYPES.includes(receiptType);
    let receiptLinePalette;
    switch(receiptLineType){
        case 'price':
            receiptLinePalette = 'neutral';
            break;
        case 'stringRetail':
        case 'priceRetail':
        case 'totalRetail':
            receiptLinePalette = 'priceRetail';
            break;
        case 'stringSale':
        case 'priceSale':
        case 'totalSale':
            receiptLinePalette = 'priceSale';
            break;
        case 'stringUrgency':
        case 'priceUrgency':
        case 'totalUrgency':
            receiptLinePalette = 'urgency';
            break;
        case 'stringCustomer':
        case 'priceCustomer':
        case 'totalCustomer':
            receiptLinePalette = 'customer';
            break;
        default:
            receiptLinePalette = 'neutral';
            break;
    }
    if ('pricePerNight' === receiptType || 'totalCost' === receiptType || 'totalCostHeading' === receiptType) withStrikethroughAbove = true;
    const { root, labelContainer, labelSpan, priceContainer } = (0, external_ReceiptLine_variants_cjs_namespaceObject.receiptLineVariant)({
        ...props,
        withStrikethroughAbove,
        withSubPrice
    });
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
        className: (0, index_cjs_namespaceObject.cn)(root(), className),
        ...props,
        children: [
            isValidReceiptType && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                children: [
                    'numberOfNights' === receiptType && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineLabel_cjs_namespaceObject.ReceiptLineLabel, {
                                className: className,
                                onClickPlainButton: onClickLabel,
                                type: "string",
                                textStyle: "body2",
                                palette: "neutral",
                                children: "Number of nights"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                className: priceContainer(),
                                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineValue_cjs_namespaceObject.ReceiptLineValue, {
                                    className: className,
                                    type: "string",
                                    textStyle: "body2",
                                    textPalette: "neutral",
                                    children: "3"
                                })
                            })
                        ]
                    }),
                    'numberOfTravelers' === receiptType && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineLabel_cjs_namespaceObject.ReceiptLineLabel, {
                                className: className,
                                type: "string",
                                textStyle: "body2",
                                palette: "neutral",
                                children: "Number of travelers"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                className: priceContainer(),
                                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineValue_cjs_namespaceObject.ReceiptLineValue, {
                                    className: className,
                                    type: "string",
                                    textStyle: "body2",
                                    textPalette: "neutral",
                                    children: "1"
                                })
                            })
                        ]
                    }),
                    'standard' === receiptType && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineLabel_cjs_namespaceObject.ReceiptLineLabel, {
                                className: className,
                                type: "string",
                                textStyle: "body2",
                                palette: "neutral",
                                children: label
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                className: priceContainer(),
                                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineValue_cjs_namespaceObject.ReceiptLineValue, {
                                    className: className,
                                    priceCurrencySymbol: currencyCode,
                                    type: "price",
                                    price: price,
                                    textStyle: "body2",
                                    textPalette: "neutral"
                                })
                            })
                        ]
                    }),
                    'dueNow' === receiptType && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineLabel_cjs_namespaceObject.ReceiptLineLabel, {
                                className: className,
                                type: "string",
                                textStyle: "body2",
                                palette: "neutral",
                                children: "Due now"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                className: priceContainer(),
                                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineValue_cjs_namespaceObject.ReceiptLineValue, {
                                    className: className,
                                    priceCurrencySymbol: currencyCode,
                                    type: "price",
                                    price: price,
                                    textStyle: "body2",
                                    textPalette: "neutral"
                                })
                            })
                        ]
                    }),
                    'dueAtPickup' === receiptType && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineLabel_cjs_namespaceObject.ReceiptLineLabel, {
                                className: className,
                                type: "string",
                                textStyle: "body2",
                                palette: "neutral",
                                children: "Due at pick-up"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                className: priceContainer(),
                                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineValue_cjs_namespaceObject.ReceiptLineValue, {
                                    className: className,
                                    priceCurrencySymbol: currencyCode,
                                    type: "price",
                                    price: price,
                                    textStyle: "body2",
                                    textPalette: "neutral"
                                })
                            })
                        ]
                    }),
                    'taxesAndFees' === receiptType && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                        children: [
                            onClickLabel && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineLabel_cjs_namespaceObject.ReceiptLineLabel, {
                                className: className,
                                type: "plainButton",
                                onClickPlainButton: onClickLabel,
                                bold: isReceiptLineBold,
                                palette: receiptLinePalette,
                                children: "Taxes and fees"
                            }),
                            !onClickLabel && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineLabel_cjs_namespaceObject.ReceiptLineLabel, {
                                className: className,
                                onClickPlainButton: onClickLabel,
                                type: "string",
                                textStyle: "body2",
                                palette: "neutral",
                                children: "Taxes and fees"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                className: priceContainer(),
                                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineValue_cjs_namespaceObject.ReceiptLineValue, {
                                    className: className,
                                    priceCurrencySymbol: currencyCode,
                                    type: "price",
                                    price: price,
                                    textStyle: "body2",
                                    textPalette: "neutral"
                                })
                            })
                        ]
                    }),
                    'pricelineTripNumber' === receiptType && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineLabel_cjs_namespaceObject.ReceiptLineLabel, {
                                className: className,
                                type: "string",
                                textStyle: "body2",
                                palette: "neutral",
                                children: "Priceline trip number"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                className: priceContainer(),
                                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineValue_cjs_namespaceObject.ReceiptLineValue, {
                                    className: className,
                                    type: "string",
                                    textStyle: "body2",
                                    textPalette: "neutral",
                                    children: value
                                })
                            })
                        ]
                    }),
                    'purchaseDate' === receiptType && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineLabel_cjs_namespaceObject.ReceiptLineLabel, {
                                className: className,
                                type: "string",
                                textStyle: "body2",
                                palette: "neutral",
                                children: "Purchase date"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                className: priceContainer(),
                                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineValue_cjs_namespaceObject.ReceiptLineValue, {
                                    className: className,
                                    type: "string",
                                    textStyle: "body2",
                                    textPalette: "neutral",
                                    children: value
                                })
                            })
                        ]
                    }),
                    'billingLabel' === receiptType && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineLabel_cjs_namespaceObject.ReceiptLineLabel, {
                                className: className,
                                type: "string",
                                textStyle: "body2",
                                palette: "neutral",
                                children: "Billing label"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                className: priceContainer(),
                                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineValue_cjs_namespaceObject.ReceiptLineValue, {
                                    className: className,
                                    type: "string",
                                    textStyle: "body2",
                                    textPalette: "neutral",
                                    children: value
                                })
                            })
                        ]
                    }),
                    'forfeitedCredit' === receiptType && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineLabel_cjs_namespaceObject.ReceiptLineLabel, {
                                className: className,
                                type: "string",
                                textStyle: "body2",
                                palette: "neutral",
                                children: "Forfeited credit"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                className: priceContainer(),
                                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineValue_cjs_namespaceObject.ReceiptLineValue, {
                                    className: className,
                                    type: "price",
                                    priceCurrencySymbol: currencyCode,
                                    price: price,
                                    textStyle: "body2",
                                    textPalette: "neutral"
                                })
                            })
                        ]
                    }),
                    'remainingBalance' === receiptType && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineLabel_cjs_namespaceObject.ReceiptLineLabel, {
                                className: className,
                                type: "string",
                                textStyle: "body2",
                                palette: "neutral",
                                children: "Remaining balance"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                className: priceContainer(),
                                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineValue_cjs_namespaceObject.ReceiptLineValue, {
                                    className: className,
                                    type: "price",
                                    priceCurrencySymbol: currencyCode,
                                    price: price,
                                    textStyle: "body2",
                                    textPalette: "neutral"
                                })
                            })
                        ]
                    }),
                    'packageSavings' === receiptType && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineLabel_cjs_namespaceObject.ReceiptLineLabel, {
                                className: className,
                                type: "string",
                                textStyle: "body2",
                                palette: "priceRetail",
                                bold: true,
                                children: "Package savings"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                className: priceContainer(),
                                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineValue_cjs_namespaceObject.ReceiptLineValue, {
                                    className: className,
                                    type: "price",
                                    priceCurrencySymbol: currencyCode,
                                    price: price,
                                    textStyle: "body2",
                                    textPalette: "priceRetail",
                                    bold: true
                                })
                            })
                        ]
                    }),
                    'creditApplied' === receiptType && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineLabel_cjs_namespaceObject.ReceiptLineLabel, {
                                className: className,
                                type: "string",
                                textStyle: "body2",
                                palette: "priceSale",
                                bold: bold,
                                children: "Credit applied"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                className: priceContainer(),
                                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineValue_cjs_namespaceObject.ReceiptLineValue, {
                                    className: className,
                                    isMinusSign: true,
                                    priceCurrencySymbol: currencyCode,
                                    type: "price",
                                    price: price,
                                    textStyle: "body2",
                                    textPalette: "priceSale"
                                })
                            })
                        ]
                    }),
                    'creditAppliedInBold' === receiptType && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineLabel_cjs_namespaceObject.ReceiptLineLabel, {
                                className: className,
                                type: "string",
                                textStyle: "body2",
                                palette: "priceSale",
                                bold: true,
                                children: "Coupon"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                className: priceContainer(),
                                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineValue_cjs_namespaceObject.ReceiptLineValue, {
                                    className: className,
                                    isMinusSign: true,
                                    priceCurrencySymbol: currencyCode,
                                    type: "price",
                                    price: price,
                                    textStyle: "body2",
                                    textPalette: "priceSale",
                                    bold: true
                                })
                            })
                        ]
                    }),
                    'coupon' === receiptType && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineLabel_cjs_namespaceObject.ReceiptLineLabel, {
                                className: className,
                                type: "string",
                                textStyle: "body2",
                                palette: "customer",
                                children: "Coupon"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                className: priceContainer(),
                                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineValue_cjs_namespaceObject.ReceiptLineValue, {
                                    className: className,
                                    isMinusSign: true,
                                    priceCurrencySymbol: currencyCode,
                                    type: "price",
                                    price: price,
                                    textStyle: "body2",
                                    textPalette: "customer"
                                })
                            })
                        ]
                    }),
                    'youPayTotal' === receiptType && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineLabel_cjs_namespaceObject.ReceiptLineLabel, {
                                className: className,
                                type: "string",
                                textStyle: "body2",
                                palette: "neutral",
                                bold: true,
                                children: "You pay total"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                className: priceContainer(),
                                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineValue_cjs_namespaceObject.ReceiptLineValue, {
                                    className: className,
                                    priceCurrencySymbol: currencyCode,
                                    type: "price",
                                    price: price,
                                    textStyle: "body2",
                                    textPalette: "neutral",
                                    bold: true
                                })
                            })
                        ]
                    }),
                    'youPayToday' === receiptType && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineLabel_cjs_namespaceObject.ReceiptLineLabel, {
                                className: className,
                                type: "string",
                                textStyle: "body2",
                                palette: "priceSale",
                                bold: true,
                                children: "You pay today"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                className: priceContainer(),
                                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineValue_cjs_namespaceObject.ReceiptLineValue, {
                                    className: className,
                                    priceCurrencySymbol: currencyCode,
                                    type: "price",
                                    price: price,
                                    textStyle: "body2",
                                    textPalette: "priceSale",
                                    bold: true
                                })
                            })
                        ]
                    }),
                    'totalCharges' === receiptType && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineLabel_cjs_namespaceObject.ReceiptLineLabel, {
                                className: className,
                                type: "string",
                                textStyle: "body2",
                                palette: "priceSale",
                                bold: true,
                                children: "Total charges"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                className: priceContainer(),
                                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineValue_cjs_namespaceObject.ReceiptLineValue, {
                                    className: className,
                                    priceCurrencySymbol: currencyCode,
                                    type: "price",
                                    price: price,
                                    textStyle: "body2",
                                    textPalette: "priceSale",
                                    bold: true
                                })
                            })
                        ]
                    }),
                    'totalCharged' === receiptType && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineLabel_cjs_namespaceObject.ReceiptLineLabel, {
                                className: className,
                                type: "string",
                                textStyle: "body2",
                                palette: "priceSale",
                                bold: true,
                                children: "Total charged"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                className: priceContainer(),
                                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineValue_cjs_namespaceObject.ReceiptLineValue, {
                                    className: className,
                                    priceCurrencySymbol: currencyCode,
                                    type: "price",
                                    price: price,
                                    textStyle: "body2",
                                    textPalette: "priceSale",
                                    bold: true
                                })
                            })
                        ]
                    }),
                    'totalOriginalCharged' === receiptType && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineLabel_cjs_namespaceObject.ReceiptLineLabel, {
                                className: className,
                                type: "string",
                                textStyle: "body2",
                                palette: "priceSale",
                                bold: true,
                                children: "Total original charged"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                className: priceContainer(),
                                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineValue_cjs_namespaceObject.ReceiptLineValue, {
                                    className: className,
                                    priceCurrencySymbol: currencyCode,
                                    type: "price",
                                    price: price,
                                    textStyle: "body2",
                                    textPalette: "priceSale",
                                    bold: true
                                })
                            })
                        ]
                    }),
                    'availableCredit' === receiptType && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineLabel_cjs_namespaceObject.ReceiptLineLabel, {
                                className: className,
                                type: "string",
                                textStyle: "body2",
                                palette: "customer",
                                bold: true,
                                children: "Available credit"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                className: priceContainer(),
                                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineValue_cjs_namespaceObject.ReceiptLineValue, {
                                    className: className,
                                    priceCurrencySymbol: currencyCode,
                                    type: "price",
                                    price: price,
                                    textStyle: "body2",
                                    textPalette: "customer",
                                    bold: true
                                })
                            })
                        ]
                    }),
                    'milesYouEarn' === receiptType && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineLabel_cjs_namespaceObject.ReceiptLineLabel, {
                                className: className,
                                type: "string",
                                textStyle: "body2",
                                palette: "neutral",
                                bold: true,
                                children: "Miles you earn"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                className: priceContainer(),
                                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineValue_cjs_namespaceObject.ReceiptLineValue, {
                                    className: "text-primary-8",
                                    type: "string",
                                    textStyle: "body2",
                                    textPalette: "neutral",
                                    bold: true,
                                    children: value
                                })
                            })
                        ]
                    }),
                    'freeSpiritPoints' === receiptType && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineLabel_cjs_namespaceObject.ReceiptLineLabel, {
                                className: className,
                                type: "string",
                                textStyle: "body2",
                                palette: "priceSale",
                                bold: true,
                                children: "Free Spirit\xae Points"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                                className: priceContainer(),
                                children: [
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineValue_cjs_namespaceObject.ReceiptLineValue, {
                                        className: className,
                                        priceCurrencySymbol: currencyCode,
                                        type: "string",
                                        textStyle: "body2",
                                        textPalette: "priceSale",
                                        bold: true
                                    }),
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineValue_cjs_namespaceObject.ReceiptLineValue, {
                                        className: className,
                                        type: "string",
                                        textStyle: "body2",
                                        textPalette: "priceSale",
                                        bold: true,
                                        children: value
                                    })
                                ]
                            })
                        ]
                    }),
                    'paymentMethod' === receiptType && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineLabel_cjs_namespaceObject.ReceiptLineLabel, {
                                className: className,
                                type: "string",
                                textStyle: "body2",
                                palette: "neutral",
                                children: "Payment method"
                            }),
                            onClickValue && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                className: priceContainer(),
                                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineValue_cjs_namespaceObject.ReceiptLineValue, {
                                    className: className,
                                    type: "plainButton",
                                    onClickPlainButton: onClickValue,
                                    textStyle: "body2",
                                    textPalette: receiptLinePalette,
                                    bold: true,
                                    children: "Affirm"
                                })
                            }),
                            !onClickValue && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                className: priceContainer(),
                                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineValue_cjs_namespaceObject.ReceiptLineValue, {
                                    className: className,
                                    type: "string",
                                    onClickPlainButton: onClickValue,
                                    textStyle: "body2",
                                    textPalette: receiptLinePalette,
                                    children: "Affirm"
                                })
                            })
                        ]
                    }),
                    'pricePerNight' === receiptType && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineLabel_cjs_namespaceObject.ReceiptLineLabel, {
                                className: (0, index_cjs_namespaceObject.cn)(labelContainer(), className),
                                type: "string",
                                onClickPlainButton: onClickLabel,
                                bold: isReceiptLineBold,
                                palette: "neutral",
                                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Span_cjs_namespaceObject.Span, {
                                    className: labelSpan(),
                                    children: "Price per night"
                                })
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                                className: priceContainer(),
                                children: [
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineValue_cjs_namespaceObject.ReceiptLineValue, {
                                        className: className,
                                        type: "price",
                                        priceCurrencySymbol: strikethroughCurrencyCode,
                                        pricePrefix: strikethroughPricePrefix,
                                        priceIsStrike: true,
                                        price: strikethroughPrice,
                                        textStyle: strikethroughTextStyle,
                                        textPalette: strikeThroughPallete,
                                        bold: strikeThroughBold
                                    }),
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineValue_cjs_namespaceObject.ReceiptLineValue, {
                                        className: className,
                                        type: "price",
                                        pricePrefix: pricePrefix,
                                        priceCurrencySymbol: currencyCode,
                                        price: price,
                                        textStyle: priceTextStyle,
                                        textPalette: receiptLinePalette,
                                        bold: isReceiptLineBold
                                    })
                                ]
                            })
                        ]
                    }),
                    'totalCost' === receiptType && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                        children: [
                            !strikethroughPrice && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineLabel_cjs_namespaceObject.ReceiptLineLabel, {
                                        className: className,
                                        type: "string",
                                        textStyle: "body2",
                                        palette: "neutral",
                                        bold: true,
                                        children: "Total cost"
                                    }),
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineValue_cjs_namespaceObject.ReceiptLineValue, {
                                        className: className,
                                        type: "price",
                                        priceCurrencySymbol: currencyCode,
                                        price: price,
                                        textStyle: "body2",
                                        textPalette: "neutral"
                                    })
                                ]
                            }),
                            strikethroughPrice && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                        className: priceContainer(),
                                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineLabel_cjs_namespaceObject.ReceiptLineLabel, {
                                            className: className,
                                            type: "string",
                                            textStyle: "body2",
                                            palette: "neutral",
                                            bold: true,
                                            children: "Total Cost"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                                        className: priceContainer(),
                                        children: [
                                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineValue_cjs_namespaceObject.ReceiptLineValue, {
                                                className: className,
                                                type: "price",
                                                priceCurrencySymbol: strikethroughCurrencyCode,
                                                pricePrefix: "was\xa0",
                                                priceIsStrike: true,
                                                price: strikethroughPrice,
                                                textStyle: strikethroughTextStyle,
                                                bold: strikeThroughBold,
                                                textPalette: "urgency"
                                            }),
                                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineValue_cjs_namespaceObject.ReceiptLineValue, {
                                                className: className,
                                                type: "price",
                                                priceCurrencySymbol: currencyCode,
                                                price: price,
                                                textStyle: priceTextStyle,
                                                textPalette: "neutral"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    'totalCostHeading' === receiptType && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                        children: [
                            !strikethroughPrice && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineLabel_cjs_namespaceObject.ReceiptLineLabel, {
                                        className: className,
                                        type: "string",
                                        textStyle: "heading4",
                                        palette: "neutral",
                                        bold: true,
                                        children: "Total"
                                    }),
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineValue_cjs_namespaceObject.ReceiptLineValue, {
                                        className: className,
                                        type: "price",
                                        priceCurrencySymbol: currencyCode,
                                        price: price,
                                        textStyle: "heading4",
                                        textPalette: "neutral",
                                        isFormatted: true
                                    })
                                ]
                            }),
                            strikethroughPrice && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                        className: priceContainer(),
                                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineLabel_cjs_namespaceObject.ReceiptLineLabel, {
                                            className: className,
                                            type: "string",
                                            textStyle: "heading4",
                                            palette: "neutral",
                                            bold: true,
                                            children: "Total"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                                        className: priceContainer(),
                                        children: [
                                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineValue_cjs_namespaceObject.ReceiptLineValue, {
                                                className: className,
                                                type: "price",
                                                priceCurrencySymbol: strikethroughCurrencyCode,
                                                pricePrefix: "was\xa0",
                                                priceIsStrike: true,
                                                price: strikethroughPrice,
                                                textStyle: strikethroughTextStyle,
                                                bold: strikeThroughBold,
                                                textPalette: "urgency"
                                            }),
                                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineValue_cjs_namespaceObject.ReceiptLineValue, {
                                                className: className,
                                                type: "price",
                                                priceCurrencySymbol: currencyCode,
                                                price: price,
                                                textStyle: priceTextStyle,
                                                textPalette: "neutral"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    'totalCostHeadingWithSubText' === receiptType && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                                className: (0, index_cjs_namespaceObject.cn)(priceContainer(), 'items-start'),
                                children: [
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineLabel_cjs_namespaceObject.ReceiptLineLabel, {
                                        className: className,
                                        type: "string",
                                        textStyle: "heading4",
                                        palette: "neutral",
                                        bold: true,
                                        children: "Total"
                                    }),
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {})
                                ]
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                                className: (0, index_cjs_namespaceObject.cn)(priceContainer()),
                                children: [
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineValue_cjs_namespaceObject.ReceiptLineValue, {
                                        className: className,
                                        type: "price",
                                        priceCurrencySymbol: currencyCode,
                                        price: price,
                                        textStyle: "heading4",
                                        textPalette: "neutral",
                                        isFormatted: true
                                    }),
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineValue_cjs_namespaceObject.ReceiptLineValue, {
                                        className: className,
                                        type: "price",
                                        priceCurrencySymbol: currencyCode2,
                                        price: price2,
                                        textStyle: "body2",
                                        textPalette: "neutral"
                                    })
                                ]
                            })
                        ]
                    }),
                    'fees' === receiptType && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineLabel_cjs_namespaceObject.ReceiptLineLabel, {
                                className: "w-fit",
                                helperIconText: helperIconText,
                                iconButtonRight: true,
                                textStyle: "body2",
                                children: label
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                className: priceContainer(),
                                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineValue_cjs_namespaceObject.ReceiptLineValue, {
                                    className: className,
                                    type: "price",
                                    pricePrefix: pricePrefix,
                                    priceCurrencySymbol: currencyCode,
                                    price: price,
                                    textStyle: priceTextStyle,
                                    textPalette: "neutral",
                                    bold: isReceiptLineBold
                                })
                            })
                        ]
                    }),
                    'protection' === receiptType && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                                className: (0, index_cjs_namespaceObject.cn)(priceContainer(), 'items-start'),
                                children: [
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineLabel_cjs_namespaceObject.ReceiptLineLabel, {
                                        className: (0, index_cjs_namespaceObject.cn)(labelContainer(), className),
                                        type: "string",
                                        onClickPlainButton: onClickLabel,
                                        bold: isReceiptLineBold,
                                        palette: "neutral",
                                        shade: "8",
                                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Span_cjs_namespaceObject.Span, {
                                            className: labelSpan(),
                                            children: "Trip protection"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                        className: "",
                                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineLabel_cjs_namespaceObject.ReceiptLineLabel, {
                                            className: (0, index_cjs_namespaceObject.cn)(labelContainer(), className),
                                            type: "string",
                                            onClickPlainButton: onClickLabel,
                                            bold: isReceiptLineBold,
                                            palette: "neutral",
                                            textStyle: "body3",
                                            shade: "10",
                                            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Span_cjs_namespaceObject.Span, {
                                                className: labelSpan(),
                                                children: "including taxes"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                className: priceContainer(),
                                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineValue_cjs_namespaceObject.ReceiptLineValue, {
                                    className: className,
                                    priceCurrencySymbol: currencyCode,
                                    type: "price",
                                    price: price,
                                    textStyle: "body2",
                                    textPalette: "neutral"
                                })
                            })
                        ]
                    }),
                    'subText' === receiptType && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineLabel_cjs_namespaceObject.ReceiptLineLabel, {
                                className: className,
                                shade: "10",
                                type: "string",
                                textStyle: "body3",
                                palette: "neutral",
                                children: label
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                className: priceContainer(),
                                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineValue_cjs_namespaceObject.ReceiptLineValue, {
                                    className: className,
                                    priceCurrencySymbol: currencyCode,
                                    type: "price",
                                    price: price,
                                    textStyle: "body3",
                                    textPalette: "neutral",
                                    pricePalette: "neutralSecondary"
                                })
                            })
                        ]
                    }),
                    'affirmFeesMonth' === receiptType && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_ReceiptLineLabel_cjs_namespaceObject.ReceiptLineLabel, {
                        className: "w-fit",
                        helperIconText: helperIconText,
                        iconButtonRight: true,
                        textStyle: "body2",
                        type: "plainButton",
                        onClickPlainButton: onClickLabel,
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Span_cjs_namespaceObject.Span, {
                                children: "as low as"
                            }),
                            "\xa0",
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Span_cjs_namespaceObject.Span, {
                                bold: true,
                                children: currencyCode
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Span_cjs_namespaceObject.Span, {
                                bold: true,
                                children: price
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Span_cjs_namespaceObject.Span, {
                                children: "/month"
                            })
                        ]
                    }),
                    'affirmFeesMo' === receiptType && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_ReceiptLineLabel_cjs_namespaceObject.ReceiptLineLabel, {
                        className: "w-fit",
                        helperIconText: helperIconText,
                        iconButtonRight: true,
                        textStyle: "body2",
                        type: "plainButton",
                        onClickPlainButton: onClickLabel,
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Span_cjs_namespaceObject.Span, {
                                children: "As low as"
                            }),
                            "\xa0",
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Span_cjs_namespaceObject.Span, {
                                bold: true,
                                children: currencyCode
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Span_cjs_namespaceObject.Span, {
                                bold: true,
                                children: price
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Span_cjs_namespaceObject.Span, {
                                children: "/mo"
                            })
                        ]
                    }),
                    'affirmInterestFreePayments' === receiptType && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_ReceiptLineLabel_cjs_namespaceObject.ReceiptLineLabel, {
                        className: "w-fit",
                        helperIconText: helperIconText,
                        iconButtonRight: true,
                        textStyle: "body2",
                        type: "plainButton",
                        onClickPlainButton: onClickLabel,
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Span_cjs_namespaceObject.Span, {
                                children: label
                            }),
                            "\xa0",
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Span_cjs_namespaceObject.Span, {
                                bold: true,
                                children: currencyCode
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Span_cjs_namespaceObject.Span, {
                                bold: true,
                                children: price
                            })
                        ]
                    })
                ]
            }),
            !isValidReceiptType && isLabelStringOrPlainButton && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_ReceiptLineLabel_cjs_namespaceObject.ReceiptLineLabel, {
                className: (0, index_cjs_namespaceObject.cn)(labelContainer(), className),
                type: labelType,
                onClickPlainButton: onClickLabel,
                bold: isReceiptLineBold,
                palette: receiptLinePalette,
                children: [
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Span_cjs_namespaceObject.Span, {
                        className: labelSpan(),
                        children: label
                    }),
                    withHelperIcon && helperIconText?.length > 0 && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Tooltip_index_cjs_namespaceObject.Tooltip, {
                        align: "start",
                        color: "neutral",
                        emphasis: true,
                        showArrow: true,
                        side: "top",
                        hoverable: true,
                        delay: 0,
                        triggerNode: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_IconButton_index_cjs_namespaceObject.IconButton, {
                            iconName: "info",
                            size: "sm",
                            type: "plainSecondary",
                            fillNone: true
                        }),
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Span_cjs_namespaceObject.Span, {
                            children: helperIconText
                        })
                    })
                ]
            }),
            !isValidReceiptType && !withSubPrice && !withStrikethroughAbove && isValuePrice && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                className: priceContainer(),
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineValue_cjs_namespaceObject.ReceiptLineValue, {
                    className: className,
                    type: "price",
                    pricePrefix: pricePrefix,
                    priceCurrencySymbol: currencyCode,
                    price: price,
                    textStyle: priceTextStyle,
                    textPalette: receiptLinePalette,
                    bold: isReceiptLineBold
                })
            }),
            !isValidReceiptType && withStrikethroughAbove && !withSubPrice && isValuePrice && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                className: priceContainer(),
                children: [
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineValue_cjs_namespaceObject.ReceiptLineValue, {
                        className: className,
                        type: "price",
                        priceCurrencySymbol: strikethroughCurrencyCode,
                        pricePrefix: strikethroughPricePrefix,
                        priceIsStrike: true,
                        price: strikethroughPrice,
                        textStyle: strikethroughTextStyle,
                        textPalette: strikeThroughPallete,
                        bold: strikeThroughBold
                    }),
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineValue_cjs_namespaceObject.ReceiptLineValue, {
                        className: className,
                        type: "price",
                        pricePrefix: pricePrefix,
                        priceCurrencySymbol: currencyCode,
                        price: price,
                        textStyle: priceTextStyle,
                        textPalette: receiptLinePalette,
                        bold: isReceiptLineBold
                    })
                ]
            }),
            !isValidReceiptType && withSubPrice && !withStrikethroughAbove && isValuePrice && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                className: priceContainer(),
                children: [
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineValue_cjs_namespaceObject.ReceiptLineValue, {
                        className: className,
                        type: "price",
                        pricePrefix: pricePrefix,
                        priceCurrencySymbol: currencyCode,
                        price: price,
                        textStyle: priceTextStyle,
                        textPalette: receiptLinePalette,
                        bold: isReceiptLineBold
                    }),
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineValue_cjs_namespaceObject.ReceiptLineValue, {
                        className: className,
                        type: "price",
                        priceCurrencySymbol: subCurrencyCode,
                        price: subPrice,
                        textStyle: subPriceTextStyle,
                        textPalette: subPricePallete,
                        bold: subPriceBold
                    })
                ]
            }),
            !isValidReceiptType && isValueStringOrPlainButton && !!value && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                className: priceContainer(),
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ReceiptLineValue_cjs_namespaceObject.ReceiptLineValue, {
                    className: className,
                    type: valueType,
                    onClickPlainButton: onClickValue,
                    textStyle: "body2",
                    textPalette: receiptLinePalette,
                    bold: isReceiptLineBold,
                    children: value
                })
            })
        ]
    });
}
exports.ReceiptLine = __webpack_exports__.ReceiptLine;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "ReceiptLine"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
